import { ComponentSizes, OptionSelectComponent, Group, SubGroup } from '@myriadgenetics/mgh-types';

export const relativeGroupSelect: OptionSelectComponent = {
  type: 'OPTION_SELECT',
  id: -1,
  name: 'Relative Group Select',
  description: 'Built in question.',
  data: {
    answerKey: 'group',
    questionKey: 'relatives.chooseRelative',
    labelKey: '',
    subtitleKey: 'relatives.chooseRelativeHint',
    placeholderKey: '',
    required: true,
    isSingleSelect: true,
    optionSize: ComponentSizes.Medium,
    selectionOptions: [
      { optionKey: 1, optionValue: 'relatives.self', optionDisplayKey: 'relatives.myself' },
      { optionKey: 2, optionValue: 'relatives.parent' },
      { optionKey: 3, optionValue: 'relatives.grand' },
      { optionKey: 4, optionValue: 'relatives.great' },
      { optionKey: 5, optionValue: 'relatives.auntOrUncle' },
      { optionKey: 6, optionValue: 'relatives.greatAuntOrUncle' },
      { optionKey: 7, optionValue: 'relatives.nieceOrNephew' },
      { optionKey: 8, optionValue: 'relatives.firstCousin' },
      { optionKey: 9, optionValue: 'relatives.sibling' },
      { optionKey: 10, optionValue: 'relatives.halfSibling' },
      { optionKey: 11, optionValue: 'relatives.child' },
      { optionKey: 12, optionValue: 'relatives.grandChild' },
    ],
  },
};

export const greatGroupSelect: OptionSelectComponent = {
  type: 'OPTION_SELECT',
  id: -2,
  name: 'Great Group Select',
  description: 'Built in question.',
  data: {
    answerKey: 'subGroup',
    questionKey: 'relatives.chooseRelative',
    labelKey: '',
    subtitleKey: 'relatives.chooseSingleRelativeHint',
    placeholderKey: '',
    required: true,
    isSingleSelect: true,
    optionSize: ComponentSizes.XSmall,
    selectionOptions: [
      {
        optionKey: 1,
        optionValue: 'relatives.greatGrandmother.unselected',
      },
      {
        optionKey: 2,
        optionValue: 'relatives.greatGrandfather.unselected',
      },
    ],
  },
};

export const grandGroupSelect: OptionSelectComponent = {
  type: 'OPTION_SELECT',
  id: -3,
  name: 'Grand Group Select',
  description: 'Built in question.',
  data: {
    answerKey: 'subGroup',
    questionKey: 'relatives.chooseRelative',
    labelKey: '',
    subtitleKey: 'relatives.chooseSingleRelativeHint',
    placeholderKey: '',
    required: true,
    isSingleSelect: true,
    optionSize: ComponentSizes.XSmall,
    selectionOptions: [
      {
        optionKey: 1,
        optionValue: 'relatives.grandmother.unselected',
      },
      {
        optionKey: 2,
        optionValue: 'relatives.grandfather.unselected',
      },
    ],
  },
};

export const parentGroupSelect: OptionSelectComponent = {
  type: 'OPTION_SELECT',
  id: -4,
  name: 'Parent Group Select',
  description: 'Built in question.',
  data: {
    answerKey: 'subGroup',
    questionKey: 'relatives.chooseRelative',
    subtitleKey: 'relatives.chooseSingleRelativeHint',
    labelKey: '',
    placeholderKey: '',
    required: true,
    isSingleSelect: true,
    optionSize: ComponentSizes.XSmall,
    selectionOptions: [
      {
        optionKey: 1,
        optionValue: 'relatives.mother',
        optionDisplayKey: 'relatives.mother',
      },
      {
        optionKey: 2,
        optionValue: 'relatives.father',
        optionDisplayKey: 'relatives.father',
      },
    ],
  },
};

export const auntOrUncleGroupSelect: OptionSelectComponent = {
  type: 'OPTION_SELECT',
  id: -14,
  name: 'Aunt or uncle Group Select',
  description: 'Built in question.',
  data: {
    answerKey: 'subGroup',
    questionKey: 'relatives.chooseRelative',
    subtitleKey: 'relatives.chooseSingleRelativeHint',
    labelKey: '',
    placeholderKey: '',
    required: true,
    isSingleSelect: true,
    optionSize: ComponentSizes.XSmall,
    selectionOptions: [
      {
        optionKey: 1,
        optionValue: 'relatives.aunt.unselected',
      },
      {
        optionKey: 2,
        optionValue: 'relatives.uncle.unselected',
      },
    ],
  },
};

export const greatAuntOrUncleGroupSelect: OptionSelectComponent = {
  type: 'OPTION_SELECT',
  id: -12,
  name: 'Great aunt or uncle Group Select',
  description: 'Built in question.',
  data: {
    answerKey: 'subGroup',
    questionKey: 'relatives.chooseRelative',
    labelKey: '',
    subtitleKey: 'relatives.chooseSingleRelativeHint',
    placeholderKey: '',
    required: true,
    isSingleSelect: true,
    optionSize: ComponentSizes.XSmall,
    selectionOptions: [
      {
        optionKey: 1,
        optionValue: 'relatives.greatAunt.unselected',
      },
      {
        optionKey: 2,
        optionValue: 'relatives.greatUncle.unselected',
      },
    ],
  },
};

export const firstCousinGroupSelect: OptionSelectComponent = {
  type: 'OPTION_SELECT',
  id: -11,
  name: 'First cousin Group Select',
  description: 'Built in question.',
  data: {
    answerKey: 'subGroup',
    questionKey: 'relatives.chooseRelative',
    labelKey: '',
    subtitleKey: 'relatives.chooseSingleRelativeHint',
    placeholderKey: '',
    required: true,
    isSingleSelect: true,
    optionSize: ComponentSizes.XSmall,
    selectionOptions: [
      {
        optionKey: 1,
        optionValue: 'relatives.femaleCousin.unselected',
      },
      {
        optionKey: 2,
        optionValue: 'relatives.maleCousin.unselected',
      },
    ],
  },
};

export const halfSiblingGroupSelect: OptionSelectComponent = {
  type: 'OPTION_SELECT',
  id: -10,
  name: 'Half sibling Group Select',
  description: 'Built in question.',
  data: {
    answerKey: 'subGroup',
    questionKey: 'relatives.chooseRelative',
    labelKey: '',
    subtitleKey: 'relatives.chooseSingleRelativeHint',
    placeholderKey: '',
    required: true,
    isSingleSelect: true,
    optionSize: ComponentSizes.XSmall,
    selectionOptions: [
      {
        optionKey: 1,
        optionValue: 'relatives.halfSister.unselected',
      },
      {
        optionKey: 2,
        optionValue: 'relatives.halfBrother.unselected',
      },
    ],
  },
};

export const siblingGroupSelect: OptionSelectComponent = {
  type: 'OPTION_SELECT',
  id: -5,
  name: 'Sibling Group Select',
  description: 'Built in question.',
  data: {
    answerKey: 'subGroup',
    questionKey: 'relatives.chooseRelative',
    labelKey: '',
    subtitleKey: 'relatives.chooseSingleRelativeHint',
    placeholderKey: '',
    required: true,
    isSingleSelect: true,
    optionSize: ComponentSizes.XSmall,
    selectionOptions: [
      {
        optionKey: 1,
        optionValue: 'relatives.sister',
        optionDisplayKey: 'relatives.sister',
      },
      {
        optionKey: 2,
        optionValue: 'relatives.brother',
        optionDisplayKey: 'relatives.brother',
      },
    ],
  },
};

export const childGroupSelect: OptionSelectComponent = {
  type: 'OPTION_SELECT',
  id: -6,
  name: 'Child Group Select',
  description: 'Built in question.',
  data: {
    answerKey: 'subGroup',
    questionKey: 'relatives.chooseRelative',
    labelKey: '',
    subtitleKey: 'relatives.chooseSingleRelativeHint',
    placeholderKey: '',
    required: true,
    isSingleSelect: true,
    optionSize: ComponentSizes.XSmall,
    selectionOptions: [
      {
        optionKey: 1,
        optionValue: 'relatives.daughter',
        optionDisplayKey: 'relatives.daughter',
      },
      {
        optionKey: 2,
        optionValue: 'relatives.son',
        optionDisplayKey: 'relatives.son',
      },
    ],
  },
};

export const grandchildGroupSelect: OptionSelectComponent = {
  type: 'OPTION_SELECT',
  id: -7,
  name: 'Grandchild Group Select',
  description: 'Built in question.',
  data: {
    answerKey: 'subGroup',
    questionKey: 'relatives.chooseRelative',
    labelKey: '',
    subtitleKey: 'relatives.chooseSingleRelativeHint',
    placeholderKey: '',
    required: true,
    isSingleSelect: true,
    optionSize: ComponentSizes.XSmall,
    selectionOptions: [
      {
        optionKey: 1,
        optionValue: 'relatives.granddaughter',
        optionDisplayKey: 'relatives.granddaughter',
      },
      {
        optionKey: 2,
        optionValue: 'relatives.grandson',
        optionDisplayKey: 'relatives.grandson',
      },
    ],
  },
};

export const nieceOrNephewSelect: OptionSelectComponent = {
  type: 'OPTION_SELECT',
  id: -9,
  name: 'Sibling Group Select',
  description: 'Built in question.',
  data: {
    answerKey: 'subGroup',
    questionKey: 'relatives.chooseRelative',
    labelKey: '',
    subtitleKey: 'relatives.chooseSingleRelativeHint',
    placeholderKey: '',
    required: true,
    isSingleSelect: true,
    optionSize: ComponentSizes.XSmall,
    selectionOptions: [
      {
        optionKey: 1,
        optionValue: 'relatives.niece',
        optionDisplayKey: 'relatives.niece',
      },
      {
        optionKey: 2,
        optionValue: 'relatives.nephew',
        optionDisplayKey: 'relatives.nephew',
      },
    ],
  },
};

export const sideOfFamilySelect = (relative: SubGroup): OptionSelectComponent => ({
  type: 'OPTION_SELECT',
  id: -8,
  name: 'Side of Family Select',
  description: 'Built in question.',
  data: {
    answerKey: 'subGroup',
    questionKey: 'relatives.sideOfFamilyQuestion',
    questionKeyParams: { relative },
    labelKey: '',
    subtitleKey: '',
    placeholderKey: '',
    required: true,
    isSingleSelect: true,
    optionSize: ComponentSizes.XSmall,
    selectionOptions: [
      {
        optionKey: 1,
        optionValue: 'relatives.sideOfFamily.maternal',
      },
      {
        optionKey: 2,
        optionValue: 'relatives.sideOfFamily.paternal',
      },
    ],
  },
});

export const relativeGroupMap: Readonly<Record<Exclude<Group, 'relatives.self'>, OptionSelectComponent>> = {
  'relatives.great': greatGroupSelect,
  'relatives.grand': grandGroupSelect,
  'relatives.parent': parentGroupSelect,
  'relatives.auntOrUncle': auntOrUncleGroupSelect,
  'relatives.greatAuntOrUncle': greatAuntOrUncleGroupSelect,
  'relatives.sibling': siblingGroupSelect,
  'relatives.firstCousin': firstCousinGroupSelect,
  'relatives.child': childGroupSelect,
  'relatives.nieceOrNephew': nieceOrNephewSelect,
  'relatives.grandChild': grandchildGroupSelect,
  'relatives.halfSibling': halfSiblingGroupSelect,
};

export default {
  relativeGroupSelect,
  greatGroupSelect,
  grandGroupSelect,
  parentGroupSelect,
  siblingGroupSelect,
  childGroupSelect,
  grandchildGroupSelect,
  sideOfFamilySelect,
  relativeGroupMap,
};
